import React, { ButtonHTMLAttributes } from 'react'
import * as S from './styles'

type Props = ButtonHTMLAttributes<HTMLButtonElement>

export function ButtonDarkerBlueOutlined({ children, ...props }: Props) {
  return <S.ButtonDarkerBlueOutlined {...props}>
    {children}
  </S.ButtonDarkerBlueOutlined>
}